"use strict";
var AjaxObservable_1 = require('./AjaxObservable');
exports.ajax = AjaxObservable_1.AjaxObservable.create;
//# sourceMappingURL=ajax.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/observable/dom/ajax.js
// module id = ./node_modules/rxjs/observable/dom/ajax.js
// module chunks = 0